<template>
  <b-modal
    id="modal-scrollable"
    scrollable
    no-close-on-backdrop
    title="www.imj.mn цахим хуудасны үйлчилгээний нөхцөл"
    @ok="handleOk"
    @cancel="handCancel"
  >
    <div class="my-4" v-for="(confirm, index) in confirmData" :key="index">
      <span class="confirm-title">{{ confirm.title }}</span>
      <p v-for="(con, idx) in confirm.items" :key="idx">
        {{ idx + 1 }}.
        {{ con.text }}
      </p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <button class="btn btn-outline-secondary" @click="cancel()">Болих</button>
      <button class="btn btn-success" @click="ok()">Зөвшөөрөх</button>
    </template>
  </b-modal>
</template>

<script>
import terms from "../data/terms.js";

export default {
  data() {
    return {
      confirmData: terms,
    };
  },
  methods: {
    handleOk() {
      this.$emit("isConfirmed");
    },
    handCancel: function () {
      this.$emit("disConfirmed");
    },
  },
};
</script>

<style scoped>
#modal-scrollable {
  font-family: "Roboto", sans-serif;
}
.confirm-title {
  font-weight: 550;
  font-size: 1.1em;
}
</style>
